import { AppConstants } from "@/common";
import { VodPagingRequestData } from "@ca.vmedia.tv/domains";
import { useMostPopularVod } from "@/stores/MostPopularVod";
import { useLinesVodStore } from "@/stores/LinesVod";
import { useUserInfoStore } from "@/stores/UserInfo";
import { storeToRefs } from 'pinia';
import { useVodPageStore } from "@/stores/VodPage";


const {
    fetchMostPopularVod
} = useMostPopularVod();
const {
	fetchInternalGenres,
} = useLinesVodStore();

const {
	fetchNewShows,
	fetchNewMovies,
	fetchRecommendedShows,
	fetchRecommendedMovies,
	fetchContinueWatching,
	fetchMostPopular,
	fetchNewReleases,
	fetchWatchAgain
} = useVodPageStore();


const UserInfoStoreModule = useUserInfoStore();
const {
	isGuest,
} = storeToRefs(UserInfoStoreModule);

export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {
		const { lineViewRows } = useAppConfig();

		fetchMostPopularVod(new VodPagingRequestData(AppConstants.MostPopularItemsInLine,1));

		fetchNewShows();

		fetchNewMovies();

		if (!isGuest.value) {
			fetchRecommendedShows();

			fetchRecommendedMovies();
		}

		fetchContinueWatching();

		fetchMostPopular();

		fetchNewReleases();
		
		if (lineViewRows.vod.includes(AppConstants.shelfKeys.vodWatchAgainCards)) {
			fetchWatchAgain();
		}
		
		fetchInternalGenres();
	}
});